var _excluded = ["variant", "text", "children", "leftIcon", "rightIcon", "isLoading", "isSuccess", "stretch", "successText", "disabled", "size", "dataTrackClass", "dataTrackId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import StyledButton, { LeftIcon as LeftIconWrapper, RightIcon, ButtonLabel } from './style';
import Icon from '../Icon';
import { LoadingIcon, CheckIcon } from '../Icons';
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
    text = _ref.text,
    children = _ref.children,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    isLoading = _ref.isLoading,
    isSuccess = _ref.isSuccess,
    stretch = _ref.stretch,
    successText = _ref.successText,
    disabled = _ref.disabled,
    size = _ref.size,
    dataTrackClass = _ref.dataTrackClass,
    dataTrackId = _ref.dataTrackId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var leftIconComponent;
  if (isLoading) {
    leftIconComponent = /*#__PURE__*/React.createElement(LeftIconWrapper, {
      variant: variant,
      size: size
    }, /*#__PURE__*/React.createElement(Icon, {
      as: LoadingIcon
    }));
  } else if (isSuccess) {
    leftIconComponent = /*#__PURE__*/React.createElement(LeftIconWrapper, {
      variant: variant,
      size: size
    }, /*#__PURE__*/React.createElement(Icon, {
      as: CheckIcon
    }));
  } else if (leftIcon || rightIcon) {
    leftIconComponent = leftIcon ? /*#__PURE__*/React.createElement(LeftIconWrapper, {
      variant: variant,
      size: size
    }, leftIcon) : null;
  }
  var buttonText = children;
  if (text) {
    buttonText = /*#__PURE__*/React.createElement(ButtonLabel, null, text);
  }
  if (isSuccess && successText) {
    buttonText = /*#__PURE__*/React.createElement(ButtonLabel, null, successText);
  }
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    variant: isSuccess ? 'proceed' : variant
  }, rest, {
    ref: ref,
    stretch: stretch,
    size: size,
    leftIcon: leftIcon,
    rightIcon: rightIcon,
    disabled: isLoading || disabled,
    isLoading: isLoading,
    isSuccess: isSuccess,
    "data-track-class": dataTrackClass,
    "data-track-id": dataTrackId
  }), leftIconComponent, buttonText, (leftIcon || rightIcon) && /*#__PURE__*/React.createElement(RightIcon, {
    variant: variant,
    size: size
  }, rightIcon));
});
Button.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary', 'cta', 'proceed', 'darkTertiary', 'ghost', 'square', 'squareprimary', 'squaresecondary', 'dotprimary', 'dotsecondary', 'round', 'rectangle']),
  size: PropTypes.oneOf(['regular', 'large', 'extraLarge']),
  stretch: PropTypes.oneOf(['full', 'auto']),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  successText: PropTypes.string,
  leftIcon: PropTypes.element,
  rightIcon: PropTypes.element
};
Button.defaultProps = {
  text: null,
  children: null,
  disabled: false,
  isLoading: false,
  className: '',
  variant: 'primary',
  size: 'regular',
  stretch: 'full',
  leftIcon: null,
  rightIcon: null,
  weight: 'medium',
  dataTrackClass: null,
  dataTrackId: null
};
Button.displayName = 'Button';
export default Button;